<template>
    <footer class="footer-main">
        <div class="container">
            <router-link class="logo" :title="'Trim Editor v' + appVersion" :to="'/'">
                <img :src="`${publicPath}imgs/DST logo small.png`" alt="DST Logo small">

                <span>
                Trim Editor
                <br>
                Version: {{ appVersion }}
            </span>
            </router-link>
        </div>
    </footer>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "FooterMain",

        computed: {
            ...mapState([
                'publicPath',
                'appVersion',
            ]),

        }

    }
</script>

<style scoped>
    .footer-main {
        margin: auto 0 0;
        padding: 30px 0;
        border-top: 1px solid #aaa;
        background: #eee;
    }

    .logo {
        display: flex;
        align-items: center;
        font-weight: 700;
        color: initial;
    }

    .logo img {
        width: 50px;
        margin: 0 6px 0 0;
        vertical-align: middle;
    }
</style>